import { jsx as _jsx } from "react/jsx-runtime";
import { AdjacentType, edgeTypeMatrix } from '@iotv/datamodel';
import { ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import { useContext } from 'react';
import { ObjectTree } from '../../../../v2/components/generic/ObjectTree/ObjectTreev2';
import { NavigationSkeleton } from '../../../common/NavigationSkeleton';
import { getSingleTypeRecursivePath } from '../../../EnititySupport/RecusiveEntityGroup/getRecursiveQueryPath';
import { handleContextMenu } from '../../clickWrappers/helpers';
import { NavigationContext } from '../../NavigationContext';
const debug = process.env.REACT_APP_DEBUG && false;
const nodeFilters = [
    { setOperation: LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: 'Gateway' }] },
];
export const AdminGatewaysTree = ({ applicationData, contextCustomer, transactionFunctions, lastKey }) => {
    const key = `${lastKey}_Gateway`;
    const navigationContext = useContext(NavigationContext);
    return (_jsx(TreeItem, { itemId: key, label: handleContextMenu('Gateways', 'Gateway', navigationContext), children: contextCustomer !== undefined ? (_jsx(ObjectTree, { uniqueTreeId: key,
            nodeEdgeMapper: applicationData,
            contextObjects: [contextCustomer],
            queryPaths: [
                {
                    stepQuery: {
                        objectTypeId: 'Group',
                        adjacencyType: AdjacentType.CHILD,
                        edgeTypeId: edgeTypeMatrix.Customer.Group.customer_has_group.edgeTypeId,
                        nodeFilters,
                    },
                    nextSteps: getSingleTypeRecursivePath({ groupObjectType: 'Group', containedObjectType: 'Gateway' }),
                },
            ],
            transactionFunctions,
            hideTopStep: true,
            maintree_rightclick: true }, key)) : (_jsx(NavigationSkeleton, {}, key)) }, key));
};
